import * as React from "react";
import { withRouter } from 'react-router'
import * as types from "../../constants/actionTypes";
import { connect } from "react-redux";


class HistoryBinder extends React.Component {

    constructor(props) {
        super(props);
        //debugger;
        props.linkObject(this.props.history);
    }

    render() { return "";}
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        linkObject: (historyObject) => {
            dispatch({ type: types.SET_HISTORY_OBJECT, history: historyObject });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HistoryBinder));
